import { h, FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import { MonetaryText } from 'up-ops-web-shared-components';
import { Locale } from '../enums/localization';
import { CurrencyConfigType } from '../types/common';

type CurrencyTextProps = {
  value: number;
  locale: string;
  isApr?: boolean;
  superscript?: boolean;
  id?: string;
  round?: boolean;
  className?: string;
  'data-auto'?: string;
};

const CurrencyText: FunctionComponent<CurrencyTextProps> = ({
  value,
  locale,
  isApr = false,
  superscript = false,
  id,
  round = false,
  className = '',
  'data-auto': dataAuto,
}) => {
  const { t } = useTranslation();

  const currencyConfig = t('common:defaultCurrencyConfig', {
    returnObjects: true,
  }) as CurrencyConfigType;

  return (
    <MonetaryText
      id={id}
      value={value}
      variant={superscript ? 'superscript' : round ? 'round' : 'decimal'}
      currencySymbol={isApr ? '%' : currencyConfig.symbol}
      currencyLocation={
        superscript
          ? 'superscript'
          : !isApr && currencyConfig.positionLeft
          ? 'before'
          : 'after'
      }
      locales={[locale, Locale.enUS]}
      className={className}
      data-auto={dataAuto}
    />
  );
};

export default CurrencyText;
